import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import {
    auctionTypeStyle,
    calculateRemainingTime,
    formatTime,
} from "../../../../../helpers/helpers";
import TimeLeftIndicator from "./TimeLeftIndicator";
import { getSocket } from "../../../../../helpers/SingletonSocketService";
import { useSelector } from "react-redux";

function ReverseLiveLotsStatus({ item, singleAuctionData, HighestBidder, setHighestBidder, auctionType, }) {
    const isDesktop = useMediaQuery({ query: "(max-width: 1600px)" });
    const isLaptop = useMediaQuery({ query: "(max-width: 1000px)" });
    const isTablet = useMediaQuery({ query: "(max-width: 790px)" });
    const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
    const { profile } = useSelector((state) => state?.profileStore);
    const [veryLessTimeStatus, setVeryLessTimeStatus] = useState(false);
    const [remainingTime, setRemainingTime] = useState(
        calculateRemainingTime(item?.offerSchedule?.endTimeAndDate)
    );

    useEffect(() => {
        const interval = setInterval(() => {
            const newRemainingTime = calculateRemainingTime(
                item?.offerSchedule?.endTimeAndDate
            );
            setRemainingTime(newRemainingTime);
            if (formatTime(newRemainingTime) < "00:15:00") {
                setVeryLessTimeStatus(true);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [item]);

    useEffect(() => {
        const socket = getSocket();
        socket?.on("newBid", (data) => {
            if (
                data?.offerId === item?._id &&
                data?.bidDetails?.organization === profile?.organization
            ) {
                setHighestBidder(true);
            } else if (data?.offerId === item?._id) {
                setHighestBidder(false);
            }
        });
    }, [profile, item, setHighestBidder]);

    useEffect(() => {
        if (item) {
            if (item?.mimumestBid === item?.myCurrentBidAmount && item?.myCurrentBidAmount !== 0) {
                setHighestBidder(true);
            } else {
                setHighestBidder(false);
            }
        }

    }, [profile, item, setHighestBidder]);


    return (
        <div
            className="valign-wrapper space-between font-16px select-label full-width"
            style={{ top: -37 }}
        >
            {!isMobile && <span className="valign-wrapper gap-10px">
                {!isLaptop && (
                    <span
                        className="valign-wrapper justify-center gap-10px font-16px"
                        style={{
                            border: "1px solid #90cb7b",
                            padding: "1px 15px",
                            borderRadius: "25px",
                            color: "#90cb7b",
                            backgroundColor: "#e3ffd9",
                        }}
                    >
                        <p
                            className="circle"
                            style={{
                                width: "9px",
                                height: "9px",
                                backgroundColor: "#90cb7b",
                            }}
                        ></p>
                        <p>Live</p>
                    </span>
                )}
                {!isTablet && (
                    <span
                        className={`${isLaptop ? "font-14px" : isDesktop ? "font-16px" : "font-18px"
                            }`}
                    >
                        Auction Id:{" "}
                        <span
                            className="cercle-purple-text"
                            style={{ textTransform: "none" }}
                        >
                            {singleAuctionData?.auctionId}
                        </span>
                    </span>
                )}
            </span>}

            {!isMobile && <span
                className={`italic-font ${isLaptop ? "font-14px" : isDesktop ? "font-16px" : "font-18px"
                    }`}
            >
                {HighestBidder
                    ? `You are Lowest bidder 💥`
                    : `You are not Lowest bidder ⚠️`}
                {isTablet && (
                    <p
                        className={`${isTablet ? "small-text" : isLaptop ? "font-14px" : isDesktop ? "font-16px" : "font-18px"
                            }`}
                    >
                        Auction Id:{" "}
                        <span
                            className="cercle-purple-text"
                            style={{ textTransform: "none" }}
                        >
                            {singleAuctionData?.auctionId}
                        </span>
                    </p>
                )}
            </span>}

            <span
                className="valign-wrapper gap-10px "
                style={{ width: isLaptop ? "350px" : "368px" }}
            >
                {veryLessTimeStatus ? (
                    <TimeLeftIndicator timeLeft={formatTime(remainingTime)} />
                ) : (
                    <span className={`${isDesktop ? "font-16px" : "font-18px"}`}>
                        Ends in{" "}
                        <span className={`cercle-purple-text`}>
                            {formatTime(remainingTime)}
                        </span>
                    </span>
                )}
                <span
                    className="valign-wrapper select-label"
                    style={{ right: "-1px", top: "2px" }}
                >
                    <div className="right-angle-triangle"></div>
                    <span
                        className={`cercle-purple white-text`}
                        style={{
                            padding: "5px 12px",
                            backgroundImage: "linear-gradient(to right, #6F2DA8, #2C1242)",
                        }}
                    >
                        {auctionTypeStyle(auctionType)}
                    </span>
                </span>
            </span>
        </div>
    );
}

export default ReverseLiveLotsStatus;
